import { render, staticRenderFns } from "./TableMundialPlayOffInformador.vue?vue&type=template&id=379050ae&scoped=true&"
import script from "./TableMundialPlayOffInformador.vue?vue&type=script&lang=js&"
export * from "./TableMundialPlayOffInformador.vue?vue&type=script&lang=js&"
import style0 from "./TableMundialPlayOffInformador.vue?vue&type=style&index=0&id=379050ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379050ae",
  null
  
)

export default component.exports